<template>
  <section class="mb-0 auto-height" id="news-list">
      <div class="container">
        <h3 class="text-center mb-0">最新消息</h3>
        <br>
        <button type="button" :class="'btn btn-secondary' + (displayTypeIdx===0?' selected':'')" @mouseover="displayTypeIdx=0;displayNewsIdx=0;">媒體報導</button>
        <button type="button" :class="'btn btn-secondary' + (displayTypeIdx===1?' selected':'')" @mouseover="displayTypeIdx=1;displayNewsIdx=0">公司消息</button>
        <br>
        <div id="newsTableBorder">
          <table class="table table-borderless" id="newsTable">
            <thead>
              <tr>
                <th scope="col">日期</th>
                <th scope="col">標題</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(news, i) in paginateNews(currentPage)" :key="i" @click="displayNewsIdx=(currentPage-1)*5+i;displayModal=true;">
                <td>{{ news.date }}</td>
                <td class="newsTitle clickable">{{ news.title }}</td>
              </tr>
              <tr>
                <td colspan="2">
                  <button type="button" :class="'btn btn-secondary' + (currentPage>1?'':' hidden')" @click="currentPage-=1">上一頁</button>
                  第 {{ currentPage }} 頁
                  <button type="button" :class="'btn btn-secondary' + (currentPage<newss.length/5?'':' hidden')" @click="currentPage+=1">下一頁</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- Modal -->
        <div v-if="newss[displayTypeIdx].length>0" class="modal-mask" :class="{noshow: !displayModal}" @click="displayModal=false">
          <div class="modal" id="newsModal" tabindex="-1" role="dialog" aria-labelledby="newsModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
              <div class="modal-content" @click.stop>
                <div class="modal-header">
                  <h5 class="modal-title">{{ newss[displayTypeIdx][displayNewsIdx].date }} {{ newss[displayTypeIdx][displayNewsIdx].title }}</h5>
                  <button type="button" class="close" @click="displayModal=false" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div v-if="displayImgIdx>=0" class="text-center">
                    <div style="width:100%">
                      <img class="newsPic" :src="newss[displayTypeIdx][displayNewsIdx].imgs[displayImgIdx]" @click="displayImgIdx=-1" alt="">
                    </div>
                  </div>
                  <div v-else class="text-left">
                    <div class="newsPicDiv" v-for="(img, i) in newss[displayTypeIdx][displayNewsIdx].imgs" :key="i">
                      <img class="newsPic" :src="img" @click="displayImgIdx=i" alt="">
                    </div>
                  </div>
                </div>
                <div class="modal-footer justify-content-start text-left">
                  <span v-html="newss[displayTypeIdx][displayNewsIdx].content"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  </section>
</template>

<script>
export default {
  name: 'NewsList',
  props: {
    newss: Array,
  },
  data() {
    return {
      displayTypeIdx: 0,
      displayNewsIdx: 0,
      displayImgIdx: -1,
      currentPage: 1,
      displayModal: false
    }
  },
  methods: {
    paginateNews(page) {
      return this.newss[this.displayTypeIdx].slice((page-1)*5, page*5)
    }
  }
}
</script>

<style scoped>
#newsTableBorder {
  border: 2px solid rgba(11, 109, 49, 0.842);
  border-radius: 5px;
}
.modal-default-button {
  float: right;
}
.hidden {
  visibility: hidden;
}
#newsModal {
  display: block;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  /* transition: opacity .3s ease; */
}
.modal-mask.noshow {
  display: none;
}
.newsPicDiv {
  display:inline-block;
  width:100%;
}
.modal-body {
  background-color: #222;
}
.modal-footer {
  overflow-y: auto;
  display: block;
  max-height: 42vh;
}
@media (min-width: 992px) {
  .newsPicDiv {
    display:inline-block;
    width:33%;
  }
  .modal-dialog {
    max-width: 65%;
  }
  .modal-footer {
    max-height: 34.5vh;
  }
}
</style>